import React, { Component } from "react";
const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/events/';



export default class AllEventsPage extends Component {
    // constructor() {
    //     super()
    // }

    render() {
        return (
            <div>
                <div className="all-events-main-div">
                    <div className="container-fluid">
                    <div className="all-events-head-div">
                    <div className="row">
                    <div className="col-6 col-md-2 col-lg-2">
                    <div className="event-list-head">
                    <h3>Sessions</h3>
                    </div>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3">
                    <div className="event-list-add-btn">
                    <button type="button" className="btn" onClick={() => this.props.CreateEvent()}>Add Session</button>
                    </div>
                    </div>
                    </div>
                       
                        </div>
                        <div className="events-list-div">
                            <div className="row">
                                <div class="col-md-12 col-lg-12 events-head-list-desktop">
                                    <div class="row">
                                        <div class="col-md-1 col-lg-1">
                                            <div class="events-list-head">
                                                <h5>Sr.No.</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-1 col-lg-1">
                                            <div class="events-list-head">
                                                <h5>Session Image</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="events-list-head">
                                                <h5>Session Name</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-1 col-lg-1">
                                            <div class="events-list-head">
                                                <h5>Session Category</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="events-list-head">
                                                <h5>Session Time</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-1 col-lg-1">
                                            <div class="events-list-head">
                                                <h5>Seats</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-1 col-lg-1">
                                            <div class="events-list-head">
                                                <h5>Organizer</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-1 col-lg-1">
                                            <div class="events-list-head">
                                                <h5>Status</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="events-list-head">
                                                <h5>Added On</h5>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-md-12 col-lg-12 events-list-desktop">
                                    {this.props.eventslist.length > 0 ?

                                     this.props.eventslist.map((item, i) => (  

                                            <div class="events-list-details" onClick={() => this.props.GetEventDetails(item.seo_url)}>
                                                <div class="row">
                                                    <div class="col-md-1 col-lg-1">
                                                        <div class="events-list-content">
                                                            <p>{i+1}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-1 col-lg-1">
                                                    <div class="events-list-content">

                                                        <img src={img_path+ item.event_image.replace(',', '')} alt="loading..."/>
                                                    </div>
                                                </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="events-list-content">
                                                            <p>{item.event_name}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-1 col-lg-1">
                                                    <div class="events-list-content">
                                                        <p>{item.event_category} ({item.event_language})</p>
                                                    </div>
                                                </div>
                                                   
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="events-list-content">
                                                            <p>{item.event_start_time} ({item.event_duration}mins)</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-1 col-lg-1">
                                                    <div class="events-list-content">
                                                        <p>{item.event_total_seats} ({item.event_already_filled_seats+item.event_filled_seats} seats filled)</p>
                                                    </div>
                                                </div>
                                                { item.organizer_details.length>0 ?
                                                    item.organizer_details.map((items , i)=>(
                                                        <div class="col-md-1 col-lg-1">
                                                        <div class="events-list-content">
                                                            <p>{items.organizer_name} </p>
                                                        </div>
                                                    </div>
                                                    ))
                                                
                                                :''}
                                                    {item.event_status === '1' || item.event_status === 1 ?
                                                        <div class="col-md-1 col-lg-1">
                                                            <div class="events-list-content">
                                                                <p>Active</p>
                                                            </div>
                                                        </div>
                                                     

                                                   : item.event_status === '0' || item.event_status === 0 ?
                                                    <div class="col-md-1 col-lg-1">
                                                   <div class="events-list-content">
                                                       <p>InActive</p>
                                                   </div>
                                               </div>
                                               :
                                               <div class="col-md-1 col-lg-1">
                                               <div class="events-list-content">
                                                   <p>Cancel</p>
                                               </div>
                                           </div>

                                            }

                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="events-list-content">
                                                            <p>{item.created_on}</p>
                                                        </div>
                                                    </div>

                                                </div>



                                            </div>
                                        ))
                                      : ''
                                                }

                                </div>
                                <div class="col-md-12 col-lg-12 events-list-mobile">
                                    {this.props.eventslist.length > 0 ?

                                     this.props.eventslist.map((item, i) => (  

                                            <div class="events-list-details" onClick={() => this.props.GetEventDetails(item.seo_url)}>
                                                <div class="row">
                                                  
                                                    <div class="col-12">
                                                    <div class="events-list-content-img">

                                                        <img src={img_path+ item.event_image.replace(',', '')} alt="loading..."/>
                                                    </div>
                                                </div>
                                               
                                                    <div class="col-xs-6 col-sm-6">
                                                        <div class="events-list-content">
                                                            <p>{item.event_name}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-1 col-lg-1">
                                                    <div class="events-list-content">
                                                        <p>{item.event_category} ({item.event_language})</p>
                                                    </div>
                                                </div>
                                                   
                                                    
                                                    <div class="col-md-1 col-lg-1">
                                                    <div class="events-list-content">
                                                        <p>{item.event_total_filled_seats} (seats already filled)</p>
                                                    </div>
                                                </div>
                                               
                                                    {item.event_status === '1' || item.event_status === 1 ?
                                                        <div class="col-md-1 col-lg-1">
                                                        <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="defaultCheckedDisabled2" checked disabled/>
                                                        <label style={{color:'black'}} class="custom-control-label" for="defaultCheckedDisabled2">Active</label>
                                                      </div>
                                                        </div>
                                                        
                                                   : <div class="col-md-1 col-lg-1">
                                                   <div class="custom-control custom-checkbox">
                                                   <input type="checkbox" class="custom-control-input" id="defaultUncheckedDisabled2" disabled/>
                                                   <label class="custom-control-label" for="defaultUncheckedDisabled2">Active</label>
                                                 </div>
                                               </div>
                                            }

                                                    

                                                </div>



                                            </div>
                                        ))
                                      : ''
                                                }

                                </div>


                            </div>
                        </div>

                    </div>

                </div>
            </div>
        )
    }
}

